import { IssueStatusType } from '@kcftech/prometheus-client';
import { getIssueStatus } from 'pages/Desk/issues/shared';
import { Lozenge } from 'shared/lozenge/Lozenge';

type StatusLozengeProps = Readonly<{
    id?: string;
    status: IssueStatusType;
}>;

export function StatusLozenge({ id, status }: StatusLozengeProps) {
    const { label, textColor, backgroundColor } = getIssueStatus(status);

    const upperLabel = label.toUpperCase();

    return (
        <Lozenge id={id} color={textColor} backgroundColor={backgroundColor}>
            {upperLabel}
        </Lozenge>
    );
}
